<div class="toolTip">
  <mat-icon>info_outline</mat-icon>
  <div class="tooltiptext">
    <strong>{{ title }}</strong><br />{{ message ?? "" }}
      <ul *ngIf="listItems">
        <li *ngFor="let item of listItems">{{ item }}</li>
      </ul>
  </div>
</div>